import { makeStyles, Tooltip } from '@material-ui/core';
import LoadingSpinner from 'components/LoadingSpinner';
import { ThemeButton } from 'components/shared';
import useFetchPdf from 'hooks/useFetchPdf';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
  loadingSpinner: {
    padding: 0
  },
  buttonContent: {
    height: '40px',
    flex: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
});

const DocumentButton = ({ caption, document }) => {
  const classes = useStyles();
  const [isLoading, fetchPdf] = useFetchPdf({ id: document.documentId });
  const content = (
    <div className={classes.buttonContent}>
      {isLoading ? (
        <LoadingSpinner size={35} classes={{ root: classes.loadingSpinner }} />
      ) : (
        caption
      )}
    </div>
  );
  return (
    <ThemeButton
      fullWidth
      themeColor={document.documentId === 0 ? 'grey' : 'accent'}
      onClick={fetchPdf}
    >
      {document.documentId === 0 ? (
        content
      ) : (
        <Tooltip title="Right click to view more" placement="top" arrow>
          {content}
        </Tooltip>
      )}
    </ThemeButton>
  );
};

DocumentButton.propTypes = {
  caption: PropTypes.string.isRequired,
  document: PropTypes.exact({
    documentId: PropTypes.number,
    documentType: PropTypes.string,
    rank: PropTypes.number,
    reportDateEnd: PropTypes.string
  }).isRequired
};

export default DocumentButton;
